var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 930,
  height: 930,
  viewBox: "0 0 930 930",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M348.75 58.125H116.25C84.1484 58.125 58.125 84.1484 58.125 116.25V348.75C58.125 380.852 84.1484 406.875 116.25 406.875H348.75C380.852 406.875 406.875 380.852 406.875 348.75V116.25C406.875 84.1484 380.852 58.125 348.75 58.125Z",
  fill: "#3D6B4A"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.45,
  d: "M813.75 58.125H581.25C549.148 58.125 523.125 84.1484 523.125 116.25V348.75C523.125 380.852 549.148 406.875 581.25 406.875H813.75C845.852 406.875 871.875 380.852 871.875 348.75V116.25C871.875 84.1484 845.852 58.125 813.75 58.125Z",
  fill: "#3D6B4A"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.45,
  d: "M348.75 523.125H116.25C84.1484 523.125 58.125 549.148 58.125 581.25V813.75C58.125 845.852 84.1484 871.875 116.25 871.875H348.75C380.852 871.875 406.875 845.852 406.875 813.75V581.25C406.875 549.148 380.852 523.125 348.75 523.125Z",
  fill: "#3D6B4A"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M813.75 523.125H581.25C549.148 523.125 523.125 549.148 523.125 581.25V813.75C523.125 845.852 549.148 871.875 581.25 871.875H813.75C845.852 871.875 871.875 845.852 871.875 813.75V581.25C871.875 549.148 845.852 523.125 813.75 523.125Z",
  fill: "#3D6B4A"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M465 537.656C505.127 537.656 537.656 505.127 537.656 465C537.656 424.873 505.127 392.344 465 392.344C424.873 392.344 392.344 424.873 392.344 465C392.344 505.127 424.873 537.656 465 537.656Z",
  fill: "#3D6B4A"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "5a5abb64dd3dfa4fae1e9171f499523b.svg";